import { zCustom } from '@nucleus/lib-shape';
import { zKey } from '@nucleus/ncu-key-prefix';
import { ISO8601Schema } from '@nucleus/src-platform/data';
import * as yup from 'yup';
import { z } from 'zod';
import { PublishableEntityBaseSchema, PublishableEntityBaseSchemaDeprecated } from './PublishableEntityBase';
import { PublishableVersionSchemaDeprecated } from './PublishableVersion';

export type PublishableSchedule = z.infer<typeof PublishableScheduleSchema>;

export const PublishableScheduleSchema = PublishableEntityBaseSchema.extend({
  entityCreatedAt: zCustom.iso(),
  publishedAt: zCustom.iso(),
  versionId: zKey.prefixedKey(),
});

/**
 * @deprecated This schema is deprecated and will be removed in the future.
 */
export const PublishableScheduleSchemaDeprecated: yup.SchemaOf<PublishableSchedule> =
  PublishableEntityBaseSchemaDeprecated.shape({
    entityCreatedAt: ISO8601Schema.required(),
    publishedAt: ISO8601Schema.required(),
    versionId: PublishableVersionSchemaDeprecated.fields.id.required(),
  });
